import React, { useMemo, useState } from 'react';
import { InputNumber, InputNumberProps, Select } from 'antd';
import { CountryCode, parsePhoneNumber, getCountryCallingCode } from 'libphonenumber-js';
import { defaultCountriesData, getFlagEmoji } from './countries';
import { SizeType } from 'antd/es/config-provider/SizeContext';

type PhoneNumberAntdProps = {
  disabled: boolean;
  size: SizeType;
  phoneNumberDefault?: string;
  defaultCountryCode?: CountryCode | string;
  'data-testid'?: string;
} & InputNumberProps;

const PhoneNumberAntd = ({
  phoneNumberDefault,
  disabled,
  size,
  onChange,
  defaultCountryCode,
  'data-testid': dataTestId,
  onBlur,
  onFocus
}: PhoneNumberAntdProps) => {
  const countriesOptions = useMemo(() => {
    return defaultCountriesData.map(itemCountry => {
      const [name, code, numPrefix] = itemCountry;
      const flag = getFlagEmoji(`${code}`);
      return (
        <Select.Option key={`${numPrefix}-${code}-${name}`} label={`${flag} +${numPrefix}`} value={numPrefix}>
          {flag} +{numPrefix} {name}
        </Select.Option>
      );
    });
  }, []);

  const { nationalNumber: nationalNumberDefault, countryCallingCode: nationalCodeDefault } = useMemo(() => {
    const defaultCode = getCountryCallingCode((defaultCountryCode as CountryCode) || 'AE');
    return phoneNumberDefault
      ? parsePhoneNumber(`+${phoneNumberDefault}`)
      : { nationalNumber: '', countryCallingCode: defaultCode };
  }, [phoneNumberDefault]);

  const [nationalNumber, setNationalNumber] = useState(nationalNumberDefault);
  const [nationalCode, setNationalCode] = useState(nationalCodeDefault);

  const handleNationalCodeChange = (code: any) => {
    setNationalCode(code);
    // @ts-ignore
    onChange && onChange({ number: nationalNumber, fullNumber: `+${code}${nationalNumber}` });
  };

  const handleNationalNumberChange = (changedNumber: any) => {
    setNationalNumber(changedNumber);
    // @ts-ignore
    onChange && onChange({ number: changedNumber, fullNumber: `+${nationalCode}${changedNumber}` });
  };

  return (
    <InputNumber
      size={size}
      controls={false}
      disabled={disabled}
      onBlur={onBlur}
      onFocus={onFocus}
      style={{ width: '100%' }}
      addonBefore={
        <Select
          style={{ width: 102 }}
          onChange={handleNationalCodeChange}
          size={size}
          defaultValue={nationalCodeDefault}
          disabled={disabled}
          dropdownStyle={{ width: 320 }}
          dropdownMatchSelectWidth={false}
          optionLabelProp="label"
          showSearch
          optionFilterProp={'key'}
          data-testid={`${dataTestId}-select`}
          onBlur={onBlur}
          onFocus={onFocus}
        >
          {countriesOptions}
        </Select>
      }
      onChange={handleNationalNumberChange}
      defaultValue={nationalNumberDefault}
      data-testid={`${dataTestId}-input`}
    />
  );
};

export default PhoneNumberAntd;
